export const LOCAL_FORM_CHANGE = 'LOCAL_FORM_CHANGE'
export const LOCAL_FORM_CLEAR = 'LOCAL_FORM_CLEAR'
export const LOCAL_LOADING = 'LOCAL_LOADING'
export const LOCAL_SENT = 'LOCAL_SENT'
export const LOCAL_GET_LOCATION = 'LOCAL_GET_LOCATION'
export const LOCAL_GET_GEO_OPTIONS = 'LOCAL_GET_GEO_OPTIONS'
export const USER_CHANGE = 'USER_CHANGE'
export const USER_AUTH_ERROR = 'USER_AUTH_ERROR'
export const USER_LOGGEDIN = 'USER_LOGGEDIN'
export const USER_LOGGEDOUT = 'USER_LOGGEDOUT'
export const USER_LOADING = 'USER_LOADING'

